//export enum SituacaoEnum {
export class TipoValidacaoAlunoEnum {
  public static Tecnico={id:1, descricao:"Técnico"};
  public static Academico={id:2, descricao:"Acadêmico"};
}
